/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("GoogleProvider", ["AIProviderBase"], function (context, cls) {
  /**
   * Google AI provider
   * @class GoogleProvider
   * @memberOf classes
   */
  class GoogleProvider extends cls.AIProviderBase /** @lends classes.GoogleProvider.prototype */ {
    constructor() {
      super("google", "Google", "remote", { rewrite: true });
    }

    /**
     * @inheritdoc
     */
    _getDirectApiHost() {
      return "https://generativelanguage.googleapis.com";
    }

    /**
     * Base URL for Google Response API
     * @returns {string}
     * @private
     */
    _getBaseUrl(model) {
      const safeModel = encodeURIComponent(model);
      return this._buildApiUrl(`v1beta/models/${safeModel}:generateContent`);
    }

    /**
     * Rewrite text using OpenAI Responses API
     * @inheritDoc
     */
    async rewrite(text, options = {}) {
      const preparedText = this._prepareRewriteInput(text);
      if (preparedText === null) {
        return null;
      }

      const instructions = this._buildRewritePrompt();
      const input = this._buildRewriteInput(preparedText, options);

      const data = await this._request(this._getBaseUrl(this._getModel("rewrite")), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-goog-api-key": this._resolveApiKey(options.apiKey)
        },
        body: {
          systemInstruction: {
            parts: [{ text: instructions }]
          },
          contents: [
            {
              role: "user",
              parts: [{ text: input }]
            }
          ]
        }
      });

      return this._extractOutputText(data);
    }

    /**
     * Extract output text from Google Responses API payload
     * @param {Object} response
     * @returns {string|null}
     * @private
     */
    _extractOutputText(response) {
      const parts = response?.candidates?.[0]?.content?.parts;
      if (!Array.isArray(parts)) {
        return null;
      }

      return parts
        .map((p) => (typeof p?.text === "string" ? p.text : ""))
        .join("")
        .trim();
    }
  }

  cls.AIProviderBase.registerProvider(GoogleProvider);
  cls.GoogleProvider = GoogleProvider;
});
